import { Dashboard, AgencyLicenses } from '@/components';

export const AgencyLicensePage = (): JSX.Element => (
  <Dashboard>
    <AgencyLicenses />
  </Dashboard>
);
